import React from "react";
import { CssBaseline } from "@mui/material";
import { Provider } from "react-redux";
import store from "./Store";
import { NotifierProvider } from "./Core/Notifier";
import { ConfirmProvider } from "./Components/Confirm";
import { ThemeProviderWrapper } from "./Drawer/Menu/ThemeContext";

interface WithAppProvidersProps {}

/**
 * Higher order function to wrap the application with redux store and other providers
 * @param Component - The component to wrap
 * @returns - A function that returns the wrapped component
 */
const withAppProviders =
  (Component: React.ComponentType<WithAppProvidersProps>) =>
  (props: WithAppProvidersProps) => {
    return (
      <Provider store={store}>
        <ThemeProviderWrapper>
          <NotifierProvider>
            {/* ConfirmProvider hosts the app's ONE confirmation dialog.
                Every destructive/lossy/warning prompt goes through
                `useConfirm()` from Components/Confirm — NEVER
                `window.confirm()`, which shows the site origin in the
                title bar and reads as a browser security warning. Lint
                enforces this via `no-restricted-syntax` in package.json.
                See Components/Confirm/README.md for the API + presets. */}
            <ConfirmProvider>
              <CssBaseline />
              <Component {...props} />
            </ConfirmProvider>
          </NotifierProvider>
        </ThemeProviderWrapper>
      </Provider>
    );
  };

export default withAppProviders;
